import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { storedProcedure } from "../../utils/storedProceduresConfig";

const RenewalPackages = (props) => {
	const [open, setOpen] = useState(false);
	const [orgDetails, setOrgDetails] = useState({});

	useEffect(() => {
		if (props.orgID) {
			axios
				.post(
					storedProcedure.getSchoolFromOrgID.url,
					storedProcedure.getSchoolFromOrgID.requestObject(props.orgID)
				)
				.then(({ data: { 0: orgDetails } }) => {
					setOrgDetails(orgDetails);
					setFormValues(orgDetails);
				})
				.catch((error) => {
					console.error("getSchoolFromOrgID error", error);
				});
		}
	}, []);

	const setFormValues = (orgValues) => {
		if (orgValues) {
			const formValues = {
				centreAddress: orgValues.AddressComplete,
				centreName: orgValues.org,
				country: orgValues.Country,
				postcode: orgValues.postcode,
				dfeNumber: orgValues.dfes,
			};
			props.updateFormValues(formValues);
		}
	};

	return <div> {props.children}</div>;
};

RenewalPackages.propTypes = {
	orgId: PropTypes.string,
	updateFormValues: PropTypes.func,
};

export default RenewalPackages;
